import { useMemo } from 'react';

import { useSearch } from '@/react/portainer/gitops/queries/useSearch';
import { SourceId } from '@/react/portainer/gitops/sources/types';

import { buildFileTree } from '@@/form-components/FilePicker/utils';

type Params = {
  sourceId: SourceId;
  gitRef: string;
  enabled: boolean;
};

export function useSourceFileTree({ sourceId, gitRef, enabled }: Params) {
  const searchQuery = useSearch({ sourceId, reference: gitRef }, { enabled });

  const fileTree = useMemo(
    () => buildFileTree(searchQuery.data || []),
    [searchQuery.data]
  );

  return {
    fileTree,
    // The paths as the source lists them: a chart is detected by looking for a
    // Chart.yaml beside a directory, which the tree shape cannot answer.
    paths: searchQuery.data ?? [],
    isLoading: searchQuery.isLoading,
  };
}
